document.addEventListener('DOMContentLoaded', function documentLoad() {
	function loadMorePosts() {
		document.getElementById('press-loadmore-button').style.display = 'none';
		document.getElementById('press-loadmore-loader').style.display = 'flex';
		const page = document.getElementById('press-pagination-page').value;
		const offset = document.getElementById('press-pagination-offset').value;
		const maxPages = document.getElementById('press-max-page').value;
		const postType = document.getElementById('press-post-type').value;
		let orderBy = '';
		if (document.getElementById('order_by')) {
			orderBy = document.getElementById('order_by').value;
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response) {
					document.getElementById('press-loadmore-button').style.display = 'flex';
					document.getElementById('press-loadmore-loader').style.display = 'none';
					document
						.querySelector('.press-loadmore-container')
						.insertAdjacentHTML('beforeend', response.html);
					document.getElementById('press-pagination-page').value = response.page;
					document.getElementById('press-pagination-offset').value = response.offset;
					if (parseInt(page, 0) + 1 > parseInt(maxPages, 0)) {
						document.getElementById('press-loadmore-button').style.display = 'none';
					}
				}
			}
		};
		const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=press_load_more_posts&page=${page}&offset=${offset}&post_type=${postType}&order_by=${orderBy}&posts_per_page=10&nonce=${ajaxNonce}`,
		);
	}

	const loadMoreButton = document.getElementById('press-loadmore-button');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function (e) {
			e.preventDefault();
			loadMorePosts();
		});
	}

	const tagsWrappers = document.querySelectorAll('.press-wrapper');
	tagsWrappers.forEach(function (tagsWrapper) {
		if (tagsWrapper.children[0].children.length === 0) {
			tagsWrapper.children[0].remove();
		}
	});
});
